
        var result = require("!!../../../../node_modules/css-loader/index.js!./user-preferences.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/controls/user-preferences.component.css
// module id = 667
// module chunks = 0